'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import styles from './LoadingView.module.scss';
interface LoadingViewProps {
  message?: string;
}
export const LoadingView = t0 => {
  const $ = _c(8);
  const {
    message
  } = t0;
  const t = useTranslations("intro");
  let t1;
  if ($[0] !== message || $[1] !== t) {
    t1 = message ?? t("aiExperience.loadingMessage");
    $[0] = message;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const text = t1;
  let t2;
  if ($[3] !== text) {
    t2 = <p className={styles.message} role="status" aria-live="polite">{text}</p>;
    $[3] = text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image className={styles.spinner} src="/intro/loading_spinner.png" alt="" aria-hidden="true" width={200} height={200} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className={styles.container}>{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};